/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState,useRef,memo,useMemo} from 'react'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import { motion } from 'framer-motion';

const MultiSelect=({
    classKey,
    dropdown,
    handleSelect,
    id,name,
    handleRemove,
    type,
    selected,
    index,
    submitSelected,
    showErrorBorder,
    setsubmitSelected})=> {
    const ref=useRef()
    const [showDropdown, setshowDropdown] = useState(false);
    const handleCheck=(item)=>selected?.map((val)=>val[id]).indexOf(item._id) > -1
    useOnClickOutside(ref,()=>{
        setshowDropdown(false)
    })

    // Check if all items are selected
    const allSelected = dropdown?.length > 0 && dropdown?.every((dropItem) => handleCheck(dropItem));

    return (
        <div className="relative w-full">
            <button onClick={()=>setshowDropdown(!showDropdown)}
                className={`slct-inpt-fld1 transition duration-150 ease-in-out ${showErrorBorder == true ? 'redBorder' : ''} `}
                type="button" id={id} data-te-dropdown-toggle-ref aria-expanded="false">
                <div className="flex flex-wrap items-center" onClick={()=>setsubmitSelected(false)}>
                    {selected?.length===0 ? 
                        <p className="text-f7 text-[#818E98] font-normal section_placeholder" >Select {type}</p>
                        :
                        
                        <>
                            {selected?.map((val,i)=>(
                                <div className="flex border border-[#c2dcef] items-center bg-[#EEF7FE] w-fit px-1 mb-1 mr-2 mt-1 added_section" key={i}>
                                    <p className="text-sm font-normal text-[#000000]">{val[name]} </p>
                                    <img src="/images/remove_gray.svg" alt="remove" className="ml-2.5 h-[30px] w-[30px] p-2" onClick={()=>{
                                        handleSelect(val,id,name,type,index)}} />
                                </div>
                            ))}
                        </>
                        
                    }
                </div>
                <img src="/images/dropdown-icon.png" alt="dropdown" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${showDropdown &&dropdown?.length>0?'transform rotate-180':''}`} />
            </button>

            {showDropdown && ( <motion.ul
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                ref={ref} className="slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                <li className="max-h-[160px] overflow-auto scroll-bar">
                    <ul>
                        {allSelected ? (
                            // Display message when all items are selected
                            <li className="text-center text-gray-500 p-2">
                                All {type}(s) selected
                            </li>
                        ) : (
                            dropdown
                                ?.filter((dropItem) => !handleCheck(dropItem)) // Hide already selected items
                                .map((dropItem) => (
                                    <li key={dropItem._id}>
                                        <a href="javascript:void(0)" className="slct_drp_dwn_optn cursor-pointer" data-te-dropdown-item-ref
                                            onClick={() => handleSelect(dropItem,id,name,type,index)}>
                                            <div className="relative flex">
                                                <span>{dropItem.name}</span>
                                            </div>
                                        </a>
                                    </li>
                                )))}
                    </ul>
                </li>
            </motion.ul>)}
        </div>
    )
}
export default memo(MultiSelect)
